export function generateCode() {
    const timestamp = new Date().getTime();
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    const random = Math.floor(array[0] % 1000000);
    return `${timestamp}${random}`;
}
